export default __webpack_public_path__ + "static/media/medium.16529c63.png";